export const ErrorService = {

    getErrorMessage: function (statusCode) {
        const getError = (() => {
            switch (statusCode) {
                case 400:
                    return 'Failed to correctly send request. Please contact service desk.';
                case 401:
                    return 'Authentication error. Please check whether you are logged in correctly.';
                case 403:
                    return 'Authorization error. Please check whether you have correct role assigned to perform this task.';
                case 404:
                    return 'Resource not found. Please contact service desk.';
                case 500:
                    return 'Server error. Please contact service desk.';
                default:
                    return 'Server error. The WebAPI is offline.';
            }
        });

        return getError();
    },
};